import script from "./Genially.vue?vue&type=script&setup=true&lang=js"
export * from "./Genially.vue?vue&type=script&setup=true&lang=js"

import "./Genially.vue?vue&type=style&index=0&id=2fee5902&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fee5902"]])

export default __exports__